import styled from 'styled-components';

export const Attribute = styled.div`
  display: grid;
  grid-template-rows: 30px 1fr;
`;

export const Label = styled.div`
  grid-row: 1/2;
  font-size: min(2vw, 3em);
`;

const getFontSize = (fontSize) => {
  if (fontSize === 'large') return 'min(7vw, 8em)';
  if (fontSize === 'medium') return 'min(5vw, 6em)';
  if (fontSize === 'v-column') return 'calc(1vw + 1.5vh + 1vmin);';
  if (fontSize === 'v-row') return 'calc(2vw + 1vh + 2vmin);';
  return 'min(3vw, 4em)';
};

export const Value = styled.div`
  grid-row: 2/3;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: ${({ fontSize }) => (getFontSize(fontSize))};
`;
